import ticketusClient from '@/_http/axiosTicketusClient';
import { catcher } from '@/_http/utils';
import { pushClient } from '@/services/push';
import { fromJS } from 'immutable';
import { dispatch } from 'nike-re-framejs';
import { ticketusMinimalTicketsFetched } from '@/mytickets/detail/handlers';

const ticketSub = pushClient.subscription({
    onMessage: msg => dispatch(['ticketus/detail/ticket-push', msg]),
    onSnapshot: snapshots => dispatch(['ticketus/detail/ticket-snapshot', snapshots])
});

export function stopTicketSub() {
    ticketSub.resetPaths([]);
}

export function startTicketSub(hashes) {
    ticketSub.resetPaths(hashes.map(hash => `/ticketus/public-ticket/mobile/sk/${hash}/`));
}

export function fetchTicket(hash) {
    ticketusClient
        .get(`public-ticket/mobile/${hash}`)
        .then(json => dispatch(['ticketus/detail/fetched', fromJS(json)]))
        .catch(error => dispatch(['ticketus/detail/failed', hash, error]));
}

export function fetchMinimalTickets(hashes) {
    ticketusClient
        .get(`public-ticket/minimal?ticket_hashes[]=${hashes.join(',')}`)
        .then(tickets => dispatch(ticketusMinimalTicketsFetched(tickets)))
        .catch(() => {});
}

export function getTicket(hash) {
    ticketusClient
        .get(`public-ticket/mobile/${hash}`)
        .then(json => dispatch(['ticketus/detail/fetched', fromJS(json)]));
}

export function fetchCombinations(hash) {
    ticketusClient
        .get(`public-ticket/${hash}/combinations`)
        .then(json => dispatch(['ticketus/combinations/fetched', hash, fromJS(json)]))
        .catch(catcher.handleMasterError);
}

export function copyTicketToSaved(ticketId) {
    return ticketusClient.post(`/saved-ticket/mobile/${ticketId}/copy`);
}
